import { omitBy, isNil, isEmpty } from 'lodash';
import { numberFormat } from '@fiverr-private/localization';
import { howLongAgo, separateNumber } from '@fiverr-private/futile';
import { NON_EXISTING_REVIEW, FILTER_TYPES } from '../constants';

export { getPackageEntryClassNames } from './entries';

export const dateStringToHowLongAgo = (dateString, locale) =>
    howLongAgo(new Date(dateString), { locale, prefix: 'reviews.general.published_time_ago.' });

export const roundHalf = (num) => Math.round(num * 2) / 2;

export const calculatePercentage = (num, total) => Math.min(100, (num / total) * 100);

export const removeEmptyEntries = (params = {}) =>
    omitBy(params, (value) => isNil(value) || value === '' || (typeof value === 'object' && isEmpty(value)));

export const formatSimpleNumber = (number) =>
    numberFormat({ value: number, options: { fallbackValue: separateNumber(number) } });

export const getFirstReviewDetails = ({ reviews, ignoredReviews, type }) => {
    if (!isEmpty(reviews)) {
        const review = reviews.find((review) => !(ignoredReviews || []).includes(review.id));
        const score = type === FILTER_TYPES.local_reviews ? review?.sort_score : review?.score;
        const firstReviewDetails = review
            ? {
                  id: review?.id,
                  score,
                  countryCode: review?.reviewer_country_code,
              }
            : NON_EXISTING_REVIEW;

        return firstReviewDetails;
    }
};

export const getLastReviewDetails = ({ reviews, ignoredReviews = [], type }) => {
    if (!isEmpty(reviews)) {
        return getFirstReviewDetails({ reviews: reviews.slice().reverse(), ignoredReviews, type });
    }
};
